import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 25,
        marginTop: 20
    },
    contentPrices: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 10
    },
    infoPrice: {
        fontSize: 14,
        fontWeight: 'bold'
    },
    descriptionInput: {
        fontSize: 14,
        fontWeight: 'bold',
        alignSelf: 'center',
        marginTop: 30
    },
    price: {
        textAlign: 'center',
        fontSize: 12,
        marginTop: 15
    }
});

export default styles;
